export const ROLES = {
  ADMIN: 'ADMIN',
  ORGANIZER: 'ORGANIZER',

  CUSTOMER: 'CUSTOMER',
} as const;

export type Role = typeof ROLES[keyof typeof ROLES];




export enum UserRole {
  admin = 'admin',
  manager = 'manager',
  employee = 'employee',
  outsourced = 'outsourced',
  customer = 'customer',
  guest = 'guest',
}
